export const ORDR_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "shipGroupSeqId", "shipmentMethodTypeId", "supplierPartyId", "supplierAgreementId", "vendorPartyId", "carrierPartyId", "carrierRoleTypeId", "facilityId", "contactMechId", "telecomContactMechId", "trackingNumber", "shippingInstructions", "maySplit", "giftMessage", "isGift", "shipAfterDate", "shipByDate", "estimatedShipDate", "estimatedDeliveryDate", "address1", "address2", "city" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "shipGroupSeqId",
            "title" : "Ship Group Seq ID"
        }, {
            "name" : "shipmentMethodTypeId",
            "title" : "Shipment Method Type ID"
        }, {
            "name" : "supplierPartyId",
            "title" : "Supplier Party ID"
        }, {
            "name" : "supplierAgreementId",
            "title" : "Supplier Agreement ID"
        }, {
            "name" : "vendorPartyId",
            "title" : "Vendor Party ID"
        }, {
            "name" : "carrierPartyId",
            "title" : "Carrier Party ID"
        }, {
            "name" : "carrierRoleTypeId",
            "title" : "Carrier Role Type ID"
        }, {
            "name" : "facilityId",
            "title" : "Facility ID"
        }, {
            "name" : "contactMechId",
            "title" : "Contact Mech ID"
        }, {
            "name" : "telecomContactMechId",
            "title" : "Telecom Contact Mech ID"
        }, {
            "name" : "trackingNumber",
            "title" : "Tracking Number"
        }, {
            "name" : "shippingInstructions",
            "title" : "Shipping Instructions"
        }, {
            "name" : "maySplit",
            "title" : "May Split"
        }, {
            "name" : "giftMessage",
            "title" : "Gift Message"
        }, {
            "name" : "isGift",
            "title" : "Is Gift"
        }, {
            "name" : "shipAfterDate",
            "title" : "Ship After Date"
        }, {
            "name" : "shipByDate",
            "title" : "Ship By Date"
        }, {
            "name" : "estimatedShipDate",
            "title" : "Estimated Ship Date"
        }, {
            "name" : "estimatedDeliveryDate",
            "title" : "Estimated Delivery Date"
        }, {
            "name" : "address1",
            "title" : "Address1"
        }, {
            "name" : "address2",
            "title" : "Address2"
        }, {
            "name" : "city",
            "title" : "City"
        } ],
        "formName" : "OrderShippingInfo",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"shippingAddres",
            title:"Shipping Addres",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "address1",
                    "title" : "Address1"
                }, {
                    "name" : "address2",
                    "title" : "Address2"
                }, {
                    "name" : "city",
                    "title" : "City"
                }
            ]
        }, {
            name:"shippingDates",
            title:"Dates",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "shipAfterDate",
                    "title" : "Ship After Date"
                }, {
                    "name" : "shipByDate",
                    "title" : "Ship By Date"
                }, {
                    "name" : "estimatedShipDate",
                    "title" : "Estimated Ship Date"
                }, {
                    "name" : "estimatedDeliveryDate",
                    "title" : "Estimated Delivery Date"
                }
            ]
        }, {
            name:"fulfillment",
            title:"FulFillment",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "carrierPartyId",
                    "title" : "Carrier Party ID"
                }, {
                    "name" : "facilityId",
                    "title" : "Facility ID"
                }, {
                    "name" : "shipmentMethodTypeId",
                    "title" : "Shipment Method Type ID"
                }, {
                    "name" : "shipGroupSeqId",
                    "title" : "Ship Group Seq ID"
                }
            ]
        }, {
            name:"shippingInfo",
            title:"Info",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "trackingNumber",
                    "title" : "Tracking Number"
                }, {
                    "name" : "shippingInstructions",
                    "title" : "Shipping Instructions"
                }, {
                    "name" : "maySplit",
                    "title" : "May Split"
                }, {
                    "name" : "giftMessage",
                    "title" : "Gift Message"
                }, {
                    "name" : "isGift",
                    "title" : "Is Gift"
                }
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "WSCO10731",
            "style" : "",
            "id" : "OrderShippingInfo_orderId",
            "title" : "Order ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Ship Group Seq ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shipGroupSeqId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_shipGroupSeqId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipment Method Type ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shipmentMethodTypeId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_shipmentMethodTypeId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Supplier Party ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "supplierPartyId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_supplierPartyId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Supplier Agreement ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "supplierAgreementId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_supplierAgreementId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Vendor Party ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "vendorPartyId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_vendorPartyId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Carrier Party ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "carrierPartyId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_carrierPartyId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Carrier Role Type ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "carrierRoleTypeId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_carrierRoleTypeId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Facility ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "facilityId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_facilityId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Contact Mech ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "contactMechId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_contactMechId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Telecom Contact Mech ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "telecomContactMechId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_telecomContactMechId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "40",
            "tabindex" : "",
            "className" : "",
            "title" : "Tracking Number",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "trackingNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_trackingNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipping Instructions",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shippingInstructions",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_shippingInstructions",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "May Split",
            "type" : "HIDDEN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "OrderShippingInfo",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "OrderShippingInfo_maySplit",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "maySplit",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Gift Message",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "giftMessage",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_giftMessage",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Is Gift",
            "type" : "HIDDEN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "OrderShippingInfo",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "OrderShippingInfo_isGift",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "isGift",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Ship After Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-12-17%2006:47:27.2",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "OrderShippingInfo",
            "timeDropdownParamName" : "shipAfterDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "OrderShippingInfo_shipAfterDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "shipAfterDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Ship By Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-12-17%2006:47:27.201",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "OrderShippingInfo",
            "timeDropdownParamName" : "shipByDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "OrderShippingInfo_shipByDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "shipByDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Estimated Ship Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-12-17%2006:47:27.201",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "OrderShippingInfo",
            "timeDropdownParamName" : "estimatedShipDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "OrderShippingInfo_estimatedShipDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "estimatedShipDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Estimated Delivery Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-12-17%2006:47:27.201",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "OrderShippingInfo",
            "timeDropdownParamName" : "estimatedDeliveryDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "OrderShippingInfo_estimatedDeliveryDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "estimatedDeliveryDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address1",
            "description" : "",
            "style" : "",
            "id" : "OrderShippingInfo_address1",
            "title" : "Address1",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address2",
            "description" : "",
            "style" : "",
            "id" : "OrderShippingInfo_address2",
            "title" : "Address2",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "city",
            "description" : "",
            "style" : "",
            "id" : "OrderShippingInfo_city",
            "title" : "City",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""

    }
    
]
